import * as types from './mutation-types'
import _ from 'lodash'
import store from '@/store'

export const mutations = {
  [types.ADD_TO_CART](state, product) {

    let items = state.cart.items,
        productExist = _.some(items, { oid: product.oid })

    if(productExist) {
      let res =_.map(items, item => {
        if(item.oid === product.oid) {
          item.pieces = product.pieces
          item.subTotal = (item.price * product.pieces).toFixed(2);
        
          //option
          if(product.o && product.o.oid) {          
            
            item.options = _.map(item.options, opt => {               

              if(opt.oid === product.o.oid) {

                if(product.o.piece === "increas") {
                  opt.number = opt.number +1
                }
                if(product.o.piece === "decreas") {
                  opt.number = opt.number -1
                }

                opt.subTotal = (opt.price * opt.number).toFixed(2);
              }
              return opt
            });
          }
          return item
        }
      })
      items = res
    } else {
      product.subTotal = (product.price * product.pieces).toFixed(2)
      items.push(product)
    }

    if(product.mode === 'services') {
      store.dispatch('shops/updateServices',{ product: items, type: 'ADD_TO_CART' })
    } else {
      store.dispatch('shops/updateProducts',{ product: product, type: 'ADD_TO_CART' })
    }
  },
  [types.REMOVE_TO_CART](state, product) {
    let items = state.cart.items;
    items = _.filter(items, (item) => { return item.oid !== product.oid });
    state.cart.items = items
    if(product.mode === 'services') {
      store.dispatch('shops/updateServices',{ product: product, type: 'REMOVE_TO_CART' })
    } else {
      store.dispatch('shops/updateProducts', { product: product, type: 'REMOVE_TO_CART' })
    }      
  },
  [types.CART_CLEAN](state) {
     state.cart.items = []
   },
}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/cart/mutations.js
// module id = null
// module chunks = 